<slm-dialog-container
  [title]="data.title"
  [buttons]="buttons"
  class="w-max-dialog block"
  (fireEvent)="buttonEvent($event.event)"
>
  <slm-data-import-container
    [notification]="notification$ | async"
    [data]="data"
    (file)="setSelectedFile($event)"
  ></slm-data-import-container>
</slm-dialog-container>
